import defaultWebPaymentMethods from '#themes/default/web/components/paymentMethods/paymentMethods.js';

import cBancontact from '#themes/avast/web/components/bancontact/bancontact.js';
import cCreditCard from '#themes/avast/web/components/creditCard/creditCard.js';
import cDirectDebit from '#themes/avast/web/components/directDebit/directDebit.js';
import cInfoBox from '#themes/avast/web/components/infoBox/infoBox.js';
import cIDeal from '#themes/avast/web/components/iDeal/iDeal.js';
import cPaymentMethod from '#themes/avast/web/components/paymentMethod/paymentMethod.js';
import cPayPalBilling from '#themes/avast/web/components/payPalBilling/payPalBilling.js';
import cSvg from '#themes/avast/web/components/svg/svg.js';
import cWireTransfer from '#themes/avast/web/components/wireTransfer/wireTransfer.js';

export default {
	components: {
		cBancontact,
		cCreditCard,
		cDirectDebit,
		cIDeal,
		cInfoBox,
		cPaymentMethod,
		cPayPalBilling,
		cSvg,
		cWireTransfer
	},
	extends: defaultWebPaymentMethods
};
